module.exports = __webpack_public_path__ + "static/media/logo-sass.9796e80b.svg";